module.exports = __webpack_public_path__ + "img/appAsset--pos-ax.2964f1e1.svg";